import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { map, of } from 'rxjs';
import { SubscriptionService } from '../services/subscription.service';

/** Timeline (advanced roadmaps) is a paid feature. */
export const roadmapsGuard: CanActivateFn = (route) => {
  const subs = inject(SubscriptionService);
  const router = inject(Router);
  const slug = route.parent?.paramMap.get('projectSlug');
  const decide = () =>
    subs.snapshot()?.plan?.has_advanced_roadmaps === false
      ? router.createUrlTree(slug ? ['/projects', slug, 'summary'] : ['/dashboard'])
      : true;
  // On a direct/deep-link navigation the layout's own load() may not have resolved
  // yet, so the guard fetches the snapshot itself rather than trusting a signal
  // someone else might still be populating.
  return subs.loaded() ? of(decide()) : subs.load().pipe(map(decide));
};
